import React from "react";
import { FileTextOutlined } from "@ant-design/icons";
import GroupBlock from "./GroupBlock";

const SectionCard = ({ section, values }) => (
  <div className="summary-wrapper">
    {section.title && (
      <div className="summary-wrapper-title">
        <FileTextOutlined
          style={{ color: "var(--ant-primary-color)", marginRight: 6 }}
        />
        {section.title}
      </div>
    )}
    {section.groups.map((group) => (
      <GroupBlock
        key={group.id}
        group={group}
        values={values}
        sectionTitle={section.title}
      />
    ))}
  </div>
);

export default SectionCard;
